export default "__VITE_ASSET__W12wy4zT__"